import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import moment from "moment";
import { commonService } from "../../../utils/commonService";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import Loader from "../../Loader/Loader";

const RateParity = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    RateParityTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPerityCheckData = async () => {
    setLoading(true);

    let perityCheckResponse = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.SnapShot + API_URL.RATESHOP.GET_PERITY_CHECK,
        body: {
          AsOfDate: para?.asOfDate,
          startDate: para?.asOfDate ? para.asOfDate.split("T")[0] : "",
          endDate: para?.asOfDate ? para.asOfDate.split("T")[0] : "",
          roomtype: null,
          propertyCode:
            para?.propertyDetail?.propertycode || para?.propertyCode,
        },
      },
      false,
    );

    let response = apiResponse(false, perityCheckResponse);

    if (response?.isValidate) {
      let dataFromApi = response?.data?.data || [];
      setData(dataFromApi);
    } else {
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (api === 0) {
      setData([
        {
          Brand: 180,
          Expedia: 180,
          "Booking.com": 165,
          Agoda: 180,
          Wholesale: 170,
        },
      ]);
      setLoading(false);
    } else {
      if (para?.asOfDate && para?.propertyCode) {
        getPerityCheckData();
      }
    }
  }, [para?.asOfDate, para?.propertyCode, api]);

  // Parse JSON data for the UI
  let displayData = [];
  if (data && data.length > 0) {
    let row = data[0];

    // Find base BAR rate (Brand)
    let baseRate = 0;
    const brandKey = Object.keys(row).find((k) => k.toLowerCase() === "brand");
    if (brandKey) {
      baseRate = parseFloat(row[brandKey]) || 0;
    }

    // Map all channels directly from response keys
    for (const key in row) {
      if (key !== "AsOfDate" && key !== "Dates") {
        let channelRate = parseFloat(row[key]) || 0;
        let diff = channelRate - baseRate;

        displayData.push({
          channelName: key,
          diff: diff,
          rate: channelRate,
        });
      }
    }
  }

  const getBarColor = (diff, name) => {
    const lowerName = name.toLowerCase();
    if (lowerName.includes("wholesale")) return "#d29922"; // orange for wholesale
    if (diff < 0) return "#da3633"; // red
    return "#238636"; // green
  };

  const getTextColor = (diff, name) => {
    if (diff < 0) return "#da3633"; // red text
    return "#238636"; // green text
  };

  const getBarWidth = (diff) => {
    if (diff >= 0) return "90%";
    // dynamically shrink slightly based on diff
    const width = 85 - Math.abs(diff);
    return `${Math.max(40, width)}%`;
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          {/* <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img
              id={commonService.generateGlobalClickTrackerID("RateParity","emailIcon", propertyDetailFromRTK?.propertyid)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.RateParityTable,
                  "RateParity",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button> */}
          <Button className="heading-menu-btns" type="button">
            <img
              id={commonService.generateGlobalClickTrackerID(
                "RateParity",
                "infoIcon",
                propertyDetailFromRTK?.propertyid,
              )}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.RateParity || "RateParity",
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          {/* <Button className="heading-menu-btns" type="button">
            <img
              src={downloadIcon}
              alt="menuIcon"
              id={commonService.generateGlobalClickTrackerID("RateParity","downloadIcon", propertyDetailFromRTK?.propertyid)}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.RateParityTable,
                  `${para?.propertyCode}-RateParity-${moment(new Date()).format("MMDDYYYY")}`
                )
              }
            />
          </Button> */}
        </div>
      )}

      <div className="px-3 mt-3">
        {loading ? (
          <div className="p-4 text-center">
            <Loader />
          </div>
        ) : displayData.length > 0 ? (
          <div className="parity-list d-flex flex-column gap-3 mb-4">
            {displayData.map((item, i) => (
              <div
                key={i}
                className="parity-row d-flex align-items-center py-2"
                style={{ borderBottom: "1px solid #e2e8f0" }}
              >
                <div
                  className="channel-name fw-bold"
                  style={{ width: "35%", color: "#334155", fontSize: "15px" }}
                >
                  {item.channelName}
                </div>
                <div
                  className="parity-bar-container flex-grow-1 mx-3"
                  style={{
                    backgroundColor: "#f1f5f9",
                    height: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <div
                    className="parity-bar"
                    style={{
                      width: getBarWidth(item.diff),
                      backgroundColor: getBarColor(item.diff, item.channelName),
                      height: "100%",
                      borderRadius: "5px",
                      transition: "width 0.5s ease-in-out",
                    }}
                  ></div>
                </div>
                <div
                  className="parity-status text-end fw-bold"
                  style={{
                    width: "20%",
                    color: getTextColor(item.diff, item.channelName),
                    fontSize: "15px",
                  }}
                >
                  {item.diff >= 0
                    ? "at BAR"
                    : `-$${Math.abs(item.diff).toFixed(2)}`}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center p-4 text-muted">
            No parity data available for tonight.
          </div>
        )}
      </div>
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={"RateParity" + tblids.RateParityTable}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default RateParity;
